<template>
  <div>
    <div class="dashboard-banner">
      <h1 class="dashboard-title">Datos de la vacante</h1>
    </div>

    <div class="card-details">
      <section class="section">
        <h2 class="subtitle my-0">Datos personales</h2>

        <div class="container">
          <div class="row">
            <div class="col-md-12 px-0 mt-4">
              <div class="table-responsive">
                <table class="custom-table w-100 d-none d-xl-table">
                  <thead>
                    <tr>
                      <th>Código de postulante</th>
                      <th>
                        Tipo de <br />
                        documento
                      </th>
                      <th>
                        Número de <br />
                        documento
                      </th>
                      <th>Nombre Completo</th>
                      <th>Empresa</th>
                      <th>Área</th>
                      <th>Cargo</th>
                      <!--<th>Días Pendientes <br> de Vacaciones</th>
              <th>Estado</th> -->
                      <th class="pr-md-3">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="o in list" :key="o.id">
                      <td class="cell-center pl-3"></td>
                      <td class="text-center"></td>
                      <td class="cell-center"></td>
                      <td class="text-center"></td>
                      <td class="cell-center"></td>
                      <td class="cell-center"></td>
                      <td class="cell-center"></td>
                      <td
                        class="cell-center d_option pr-md-2 position-relative"
                      >
                        <DropdownTable>
                          <template slot="dropdown-content">
                            <DropdownItem
                              text="Ver CV"
                            />
                          </template>
                        </DropdownTable>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="row buttons-container mb-0">
            <div class="col text-right">
              <router-link
                :to="{ name: 'job-openings-list' }"
                class="button button-light"
              >
                Volver
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { Alert, DropdownTable, DropdownItem } from "wize-admin";
import { EmployeeService } from "@/core/services";

export default {
  data() {
    return {
      list: [],
    };
  },
  components: {
    DropdownTable,
    DropdownItem,
  },
  methods: {
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await EmployeeService.get(id);
        const payload = response.payload;
        this.supplier = { ...payload };
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "supplier-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    this.load(this.$route.params.supplierId);
  },
};
</script>

<style lang="stylus" scoped>
// @import '../Styles/supplier-details';
</style>
